const isPwc = (organizationName?: string) => (
  organizationName?.toLowerCase() === "pwc-us"
);

export default isPwc;
